// --- Date Utilities ---

export const monthStringToDate = (ym: string): Date => {
  const [yStr, mStr] = (ym ?? "").split("-");
  const y = Number(yStr);
  const m = Number(mStr);
  if (!y || !m) throw new Error(`Invalid latest_month '${ym}'. Expected 'yyyy-mm'.`);
  return new Date(Date.UTC(y, m - 1, 1));
};

export const toExcelSerialFromUTCDate = (dUTC: Date): number => {
  const epoch = Date.UTC(1899, 11, 30);
  const msPerDay = 24 * 60 * 60 * 1000;
  return (dUTC.getTime() - epoch) / msPerDay;
};

export const fromExcelSerialToUTCDate = (serial: number): Date => {
  const epoch = Date.UTC(1899, 11, 30);
  const msPerDay = 24 * 60 * 60 * 1000;
  return new Date(epoch + serial * msPerDay);
};

export const formatAsM1YYYY = (dUTC: Date): string => {
  const y = dUTC.getUTCFullYear();
  const m = dUTC.getUTCMonth() + 1;
  return `${m}/1/${y}`;
};
